import React, { Component } from 'react';
import './Tenants.css';

class Tenants extends Component {
  render() {
    if (this.props.data) {
      let tenants = this.props.data.map(tenant => {
        return (
          <tr>
            <td>{tenant.id}</td>
            <td>{tenant.displayName}</td>
            {tenant.aspects && tenant.aspects.length ? (
              <td rowSpan={tenant.aspects.length}>
                {tenant.aspects.map(aspect => {
                  return (
                    <div>
                      {`${aspect.namespace ? aspect.namespace : 'NA'} : ${
                        aspect.identifier ? aspect.identifier : 'NA'
                      }`}
                      <br />
                    </div>
                  );
                })}
              </td>
            ) : (
              <td>N/A</td>
            )}
            {/* <td>{`${tenant.aspects ? tenant.aspects[0].namespace : 'NA'} : ${
              tenant.aspects ? tenant.aspects[0].identifier : 'NA'
            }`}</td> */}
            <td>
              {new Date(tenant.meta.created).toLocaleDateString('en-US', {
                hour: '2-digit',
                minute: '2-digit'
              })}
            </td>
          </tr>
        );
      });

      return (
        <table>
          <thead>
            <tr>
              <td>Id</td>
              <td>Name</td>
              <td>Aspects</td>
              <td>Created Date</td>
            </tr>
          </thead>
          <tbody>{tenants}</tbody>
        </table>
      );
    } else {
      return false;
    }
  }
}

export default Tenants;
